import React, { Component } from 'react'
import { isMobile, getMobileOperatingSystem } from 'utils'
import Icon from 'components/icon/icon'

export default class ScreenCover extends Component {
	state = {
		visible: false
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				visible: true
			})
		},500)
	}

	getCopy = _ => {
		const os = getMobileOperatingSystem()

		const copy = {
			storeName: os == 'Android' ? 'Play Store' : 'App Store',
			storeUrl: os == 'Android' ? 'https://play.google.com/store/apps/details?id=co.yclabs.hassl&hl=en_AU' : 'https://itunes.apple.com/us/app/hassl/id1440914929?mt=8',
			storeIcon: os == 'Android' ? 'android-play-store' : 'apple-app-store'
		}

		return copy
	}

	dismiss = _ => {
		this.setState({
			visible: false
		})
	}

	render() {
		if(!isMobile()){
			return null
		}

		const { visible } = this.state

		const copy = this.getCopy()

		let className = 'screen-cover'

		if(visible){
			className += ' visible'
		}

		return (
			<div className={className}>
				<div>
					<h2>
						On the go?
					</h2>
					<p>
						We recommend the official Hassl app from the { copy.storeName }!
					</p>
					<a 
						className="download-icon"
						href={copy.storeUrl}
						target="_blank"
					>
						<img src={document.base+'/images/icons/'+copy.storeIcon+'.png'} />
					</a>
					<span 
						className="subtitle"
						onClick={this.dismiss}
					>
						No thanks, continue in browser
					</span>
					<img 
						src={document.base + "/images/logo.png"} 
						className="logo"
					/>
				</div>
				<a 
					className="help-link"
					href="https://hassl.co/contact/" 
					target="_blank"
				>
					<Icon name="fe-help-circle" />
					Need a hand with something?
				</a>
			</div>
		)
	}
}
